import { RelatedEventsLogsResponseItemModel, RelatedEventsTableInfoModel } from "../../app/data/documents/relatedEventsLogsModels";

export default interface RelatedEventsLogsState {
  requestStarted: boolean;
  requestSucceed: boolean;
  requestFailed: boolean;
  requestError: string;
  requestCreator: string;
  recordItems: RelatedEventsLogsResponseItemModel[];
  downloadCsv: boolean;
  tableInfo: RelatedEventsTableInfoModel;
  recordsRequest: PaginationModel | null;
};

export const initialRelatedEventsLogsState: RelatedEventsLogsState = {
  requestStarted: false,
  requestSucceed: false,
  requestFailed: false,
  requestError: "",
  requestCreator: "",
  recordItems: [],
  recordsRequest: null,
  downloadCsv: false,
  tableInfo: {title: "", description: "", sections: []}
};
  
export interface PaginationModel {
  page: number,
  last: number,
};